// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlighted-services-row[data-v-6f7077b6]{display:flex;flex-direction:column;align-items:flex-start;margin-top:32px;margin-bottom:64px;gap:24px}@media(min-width:768px){.highlighted-services-row[data-v-6f7077b6]{flex-direction:row;gap:16px}}@media(min-width:1024px){.highlighted-services-row[data-v-6f7077b6]{margin-top:12px;gap:24px}}.fedex-disclaimer[data-v-6f7077b6]{font-size:11px;color:#8b8bac}", ""]);
// Exports
module.exports = exports;
